import { apiClient } from "@/lib/api-client";
import { mapStudioListResponse } from "@/lib/api-mappers";
import type { ApiStudioListResponse } from "@/types/api-auth";
import type { SessionUser, Studio, StudioRole, User } from "@/types";

export type StudiosSyncResult = {
  studios: Studio[];
  studioRoles: StudioRole[];
  currentStudioId: string | "all" | null;
};

/** Fetch GET /studios and map to client studio state. Returns null when the request fails. */
export async function fetchStudiosFromApi(): Promise<StudiosSyncResult | null> {
  const res = await apiClient<ApiStudioListResponse>("/studios", { skipAutoRedirect: true });
  if (!res.success || !res.data) return null;
  return mapStudioListResponse(res.data);
}

/** Build persisted session user snapshot from a mapped User. */
export function buildSessionUser(mappedUser: User): SessionUser {
  return {
    id: mappedUser.id,
    email: mappedUser.email,
    name: mappedUser.name,
    emailVerified: mappedUser.emailVerified,
    onboardingComplete: mappedUser.onboardingComplete,
    accountVertical: mappedUser.accountVertical,
    preferredUiLocale: mappedUser.preferredUiLocale ?? null,
    studioIds: mappedUser.studios.map((s) => s.id),
    studioRoles: mappedUser.studioRoles,
  };
}
